<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M17.4444 17.4444H6.55556V6.55556H12V5H6.55556C6.143 5 5.74733 5.16389 5.45561 5.45561C5.16389 5.74733 5 6.143 5 6.55556V17.4444C5 17.857 5.16389 18.2527 5.45561 18.5444C5.74733 18.8361 6.143 19 6.55556 19H17.4444C18.3 19 19 18.3 19 17.4444V12H17.4444V17.4444ZM13.5556 5V6.55556H16.3478L8.70222 14.2011L9.79889 15.2978L17.4444 7.65222V10.4444H19V5H13.5556Z"
      fill="currentColor"
    />
  </svg>
</template>
